// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".enterprise_header_infos-module__container--1ZxIG{font-weight:400;font-size:16px;line-height:24px;letter-spacing:0px;text-align:left}.enterprise_header_infos-module__item--UaA6G{margin-bottom:8px}.enterprise_header_infos-module__label--28OH_{color:#616161}.enterprise_header_infos-module__value--3Ve8m{color:#303030}.enterprise_header_infos-module__link--2yAKF:hover{text-decoration:underline}\n", ""]);
// Exports
exports.locals = {
	"container": "enterprise_header_infos-module__container--1ZxIG",
	"item": "enterprise_header_infos-module__item--UaA6G",
	"label": "enterprise_header_infos-module__label--28OH_",
	"value": "enterprise_header_infos-module__value--3Ve8m",
	"link": "enterprise_header_infos-module__link--2yAKF"
};
module.exports = exports;
